<script>
//https://www.toptal.com/developers/keycode/table
export default {
  name: "KeyListener",
  data() {
    return {
      keys: {},
      keysToMatch: [17, 16, 68], // CTRL, Shift, D,
      callback: () =>
        console.warn("🔑 KeyListener: 🛑 Set up your Trigger Event")
    };
  },
  methods: {
    handleKeyDown(event) {
      this.keys[event.which] = true;
    },
    handleKeyUp(event) {
      delete this.keys[event.which];
    },
    setKeyListener(keysToMatch, callback, adminOnly = true) {
      if (adminOnly) {
        // TODO - if dev, debug, or user is admin
      }
      if (Array.isArray(keysToMatch)) {
        this.keysToMatch = keysToMatch;
      } else {
        console.warn(
          `🔑 KeyTrigger: 🛑 keysToMatch (first parameter) should be an array. Instead got ${typeof keysToMatch}`
        );
      }

      if (typeof callback === "function") {
        this.callback = callback;
      } else {
        console.warn(
          `🔑 KeyListener: 🛑 Callback (second parameter) should be a function. Instead got ${typeof callback}`
        );
      }

      this.setEventListeners();
    },
    setEventListeners() {
      window.addEventListener("keydown", this.handleKeyDown);
      window.addEventListener("keyup", this.handleKeyUp);
    }
  },
  watch: {
    keys: {
      deep: true,
      handler() {
        // if CTRL and D and Shift are all pressed, activate debug mode
        if (this.keysToMatch.every((key) => this.keys[key])) {
          if (this.callback) {
            this.callback();
          }
        }
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
  }
};
</script>
